module.exports = __webpack_public_path__ + "static/img/3.0e158c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/3.png
// module id = kVlj
// module chunks = 0